// extracted by mini-css-extract-plugin
export default {"menu":"profile-menu_menu__b3-nl","menuActive":"profile-menu_menuActive__NFoc2"};